import { create } from 'zustand'
import { createSelectors } from '~/shared/lib/zustand-utils'

interface AlertStore {
  alertVisible: boolean
  alertMessage: string
  alertTimerId: NodeJS.Timeout | null
  showAlert: (message: string) => void
  hideAlert: () => void
}

const alertStore = createSelectors(
  create<AlertStore>((set, get) => ({
    alertVisible: false,
    alertMessage: '',
    alertTimerId: null,
    showAlert: (message: string) => {
      const currentTimerId = get().alertTimerId
      if (currentTimerId) {
        clearTimeout(currentTimerId)
      }

      const timerId = setTimeout(() => {
        set({ alertVisible: false, alertMessage: '', alertTimerId: null })
      }, 4000)

      set({
        alertVisible: true,
        alertMessage: message,
        alertTimerId: timerId,
      })
    },
    hideAlert: () => {
      const currentTimerId = get().alertTimerId
      if (currentTimerId) {
        clearTimeout(currentTimerId)
      }
      set({ alertVisible: false, alertMessage: '', alertTimerId: null })
    },
  })),
)

export function useAlertStoreSelectors() {
  const alertVisible = alertStore.use.alertVisible()
  const alertMessage = alertStore.use.alertMessage()
  const alertTimerId = alertStore.use.alertTimerId()
  const showAlert = alertStore.use.showAlert()
  const hideAlert = alertStore.use.hideAlert()

  return { alertVisible, alertMessage, alertTimerId, showAlert, hideAlert }
}
